import { createSlice } from "@reduxjs/toolkit";

const selectedUserSlice = createSlice({
  name: "selectedUsers",
  initialState: {
    selectedUsers: [],
  },
  reducers: {
    addSelectedUsers: (state, action) => {
      state.selectedUsers.push(action.payload); // Add document ID
    },
    removeSelectedUsers: (state, action) => {
      state.selectedUsers = state.selectedUsers.filter((id) => id !== action.payload); // Remove document ID
    },
    resetSelectedUsers: (state) => {
      state.selectedUsers = []; // Reset state to an empty array
    },
  },
});

export const { addSelectedUsers, removeSelectedUsers,resetSelectedUsers } = selectedUserSlice.actions;

export default selectedUserSlice.reducer;
